import Vue from 'vue';
import adjustmentTransformer from './../../transformers/adjustment';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('RefreshStockProducts');
  resolve(adjustmentTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(adjustmentTransformer.fetch(errors));
};

export default adjustment => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/adjustments', adjustment)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/store.js